import { Redirect, useRouteMatch } from 'react-router-dom';
import { VIEW_MODE } from 'store/shared/fixtures';
import { useSelector, useDispatch } from 'react-redux';
import { disableEntitiesScroll, enableEntitiesScroll } from 'store/shared/actions';
import { getAppEntitiesScrollDisplayState, getViewMode } from 'store/shared/selectors';
import { lazy, Suspense, useEffect } from 'react';
import { Container } from './styles';

const Grid = lazy(() => import('./grid'));
const List = lazy(() => import('./list'));
const Table = lazy(() => import('./table'));

const COMPONENTS_MAP = {
  [VIEW_MODE.GRID]: Grid,
  [VIEW_MODE.LIST]: List,
  [VIEW_MODE.TABLE]: Table,
};

const ViewMode = (props) => {
  const mode = useSelector(getViewMode);
  const dispatch = useDispatch();
  const Component = COMPONENTS_MAP[mode];

  const isScrollable = useSelector(getAppEntitiesScrollDisplayState);

  useEffect(() => {
    if(props.openedItemId && isScrollable) {
      dispatch(disableEntitiesScroll());
    } else if(!props.openedItemId && !isScrollable) {
      dispatch(enableEntitiesScroll());
    }
  }, [isScrollable, props.openedItemId]);

  if (!Component) {
    const { url } = useRouteMatch();
    const redirectUrl = `${url}${mode}`;

    return <Redirect to={redirectUrl} />;
  }

  if (mode === VIEW_MODE.GRID) {
    return (
      <Suspense fallback={<Container />}>
        <Grid {...props} />
      </Suspense>
    );
  }

  if (mode === VIEW_MODE.LIST) {
    return (
      <Suspense fallback={<Container />}>
        <List {...props} />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<Container />}>
      <Table {...props} />
    </Suspense>
  );
};

export default ViewMode;
